import {
  ChevronDownIcon,
  GithubIcon,
  RightArrowIcon,
  SketchNoteLogoTwoIcon,
} from '@sketchnote/icons';
import { Button, userSelectStyles } from '@sketchnote/shared-components';
import React, { useState } from 'react';
import Select from 'react-select';

import { useFileExploreStore } from '../store';
import { ExploreHeader } from './home';

export const Github = (): JSX.Element => {
  const {
    closeExploreMenu,
    setNavigation,
    githubAuthUrl,
    githubAccess,
    githubRepos,
    githubUserRepos,
    onGitRepoSelect,
    onRemoveGithubRepo,
  } = useFileExploreStore();

  const [selectedRepoId, setSelectedRepoId] = useState<number>(0);

  const hanldeCloseMenu = () => {
    closeExploreMenu();
  };
  const handleOnBack = () => {
    setNavigation('integrations');
  };

  const handleRepoSelect = (option) => {
    if (option.value) {
      setSelectedRepoId(option.value);
    }
  };

  const onRepoAdd = () => {
    const selectedRepo = githubRepos.find((repo) => repo.id === selectedRepoId);
    if (selectedRepo) {
      onGitRepoSelect({ repo: selectedRepo });
    }
  };

  const onRepoRemove = (repoName) => {
    if (repoName) {
      onRemoveGithubRepo({ repoName });
    }
  };

  const useRepoNames = githubUserRepos.map((userRepos) => userRepos.repoName);

  const githubRepoOptions = githubRepos
    ?.filter((repo) => !useRepoNames.includes(repo.name))
    .map((repo) => ({
      value: repo.id,
      label: repo.full_name,
    }));

  return (
    <div>
      <div className="h-60 bg-white sticky top-0 z-10">
        <ExploreHeader title="" onBackClick={handleOnBack} onCloseClick={hanldeCloseMenu} />
      </div>
      <div className="flex mb-16">
        <div className="mr-16">
          <GithubIcon size={42} />
        </div>
        <div>
          <div className="text-base font-semibold">GitHub</div>
          <div className="text-sm text-gray-600 mb-8 font-medium">Software Development</div>
        </div>
      </div>
      <div className="mb-16">
        <div className="text-sm font-medium mb-16">Github Repository</div>
        {githubAccess ? (
          <Select
            options={githubRepoOptions}
            placeholder="Select a Repository"
            onChange={handleRepoSelect}
            styles={userSelectStyles}
            components={{
              DropdownIndicator: ChevronDownIcon as any,
              IndicatorSeparator: () => null,
            }}
          />
        ) : (
          <a href={githubAuthUrl}>
            <Button>Authenticate Github</Button>
          </a>
        )}
      </div>
      {!!selectedRepoId && (
        <div className="border border-gray-300 rounded-sm p-16 mb-16">
          <div className="flex mb-8">
            <GithubIcon width={24} height={24} className="mr-8" />
            <RightArrowIcon height={24} className="mr-8 text-gray-500" />
            <SketchNoteLogoTwoIcon fill="#ffffff" width={24} height={24} />
          </div>
          <div className="text-md mb-8">
            When an <strong>issue</strong> is created in this repository, create a{' '}
            <strong>new task</strong>
          </div>
          <button
            onClick={onRepoAdd}
            className="text-sm text-primary-500 font-medium"
            type="button"
          >
            Add to board →
          </button>
        </div>
      )}
      <div className="border-t border-gray-300 pt-16">
        {githubUserRepos.length > 0 && (
          <div className="text-sm font-medium mb-16">Connected Repositories</div>
        )}
        {githubUserRepos?.map((userRepo) => (
          <div
            key={userRepo._id}
            className="border border-gray-300 rounded-sm p-16 mb-16 flex align-middle justify-between"
          >
            <div className="text-sm font-medium flex">
              <GithubIcon width={24} height={24} className="mr-8" />
              {userRepo.repoName}
            </div>
            <button
              onClick={() => onRepoRemove(userRepo.repoName)}
              className="text-sm prim text-red-500 font-medium"
              type="button"
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
